
















import { Component, Watch, Prop, Vue } from 'vue-property-decorator';
import DatePicker from 'vuejs-datepicker/src/components/Datepicker.vue';
import moment from 'moment-timezone';

@Component({
  components: {
    DatePicker
  }
})
export default class DateRangePicker extends Vue {
  @Prop() startDate!: any;
  @Prop() endDate!: any;
  @Prop() disabledDate!: boolean;
  @Prop({ default: 0 }) limitDays?: number;

  public selectedDate: any = {
    startDate: this.startDate,
    endDate: this.endDate,
  };

  public state: any = {
    startDisabledDates: {
      to: this.disabledDate
        ? new Date(
          this.currentDate.year,
          this.currentDate.month - 36,
          this.currentDate.day
        )
        : null,
      from: null
    },
    endDisabledDates: {
      to: this.disabledDate
        ? new Date(this.currentDate.year, this.currentDate.month, 1)
        : this.limitDays ? new Date(
          this.currentDate.year,
          this.currentDate.month,
          this.currentDate.day - 1
        ) : null,
      from: null,
    }
  };

  get dateObj () {
    return {
      startDate: this.startDate,
      endDate: this.endDate,
    }
  }

  @Watch('dateObj', { deep: true })
  watchStartDate(newVal: { startDate: string, endDate: string }) {
    this.selectedDate.startDate = newVal.startDate;
    this.selectedDate.endDate = newVal.endDate;
    this.updateDates();
  }

  updateDates() {
    if (this.selectedDate.endDate && !this.limitDays) {
      this.state.startDisabledDates.from = new Date(
        moment(this.selectedDate.endDate).year(),
        moment(this.selectedDate.endDate).month(),
        moment(this.selectedDate.endDate).date() + 1
      );
    }
    if (this.selectedDate.startDate) {
      if (
        this.limitDays &&
        moment(this.selectedDate.endDate).startOf('day').valueOf() >= moment(this.selectedDate.startDate).add(this.limitDays, 'days').startOf('day').valueOf()
      ) {
        this.selectedDate.endDate = moment(this.selectedDate.startDate).add(this.limitDays - 1, 'days').format('YYYY-MM-DD');
      } else if (moment(this.selectedDate.endDate).startOf('day').valueOf() < moment(this.selectedDate.startDate).startOf('day').valueOf()) {
        this.selectedDate.endDate = moment(this.selectedDate.startDate).format('YYYY-MM-DD');
      }
      this.state.endDisabledDates.to = new Date(
        moment(this.selectedDate.startDate).year(),
        moment(this.selectedDate.startDate).month(),
        moment(this.selectedDate.startDate).date()
      );
      if (
        this.limitDays &&
        moment().valueOf() > moment(this.selectedDate.startDate).add(this.limitDays, 'days').valueOf()
      ) {
        this.state.endDisabledDates.from = new Date(
          moment(this.selectedDate.startDate).year(),
          moment(this.selectedDate.startDate).month(),
          moment(this.selectedDate.startDate).date() + this.limitDays,
        );
      } else {
        this.state.endDisabledDates.from = null;
      }
    }
    this.handleUpdateDate();
  }

  get currentDate() {
    const now = new Date();
    return {
      year: now.getFullYear(),
      month: now.getMonth(),
      day: now.getDate() + 1
    };
  }

  handleUpdateDate() {
    this.selectedDate = {
      startDate: this.selectedDate.startDate
        ? moment(this.selectedDate.startDate).format('YYYY-MM-DD')
        : '',
      endDate: this.selectedDate.endDate
        ? moment(this.selectedDate.endDate).format('YYYY-MM-DD')
        : '',
    };
    this.$emit('update-dates', this.selectedDate);
  }

  resetDate() {
    this.selectedDate = {
      startDate: '',
      endDate: '',
    };
    this.state.startDisabledDates.from = null;
    this.state.endDisabledDates.to = this.disabledDate
      ? new Date(this.currentDate.year, this.currentDate.month, 1)
      : null;
    this.$emit('update-dates', this.selectedDate);
  }
}
